import {
    DataFilterOperator,
    DataTypeOperator,
    Filter,
    FilterGroup,
    FilterRule
} from 'crqlar-react-common/dist/models/audience/filter.model';
import {
    GUEST_CATEGORY_NIGHTS_FIELD,
    GUEST_CATEGORY_STAYS_FIELD
} from 'crqlar-react-common/dist/models/profile/guestCategory.model';

/**
 * The two counters a guest category can judge and the comparisons it accepts. Mirrors `GuestCategoryRulesV3`
 * in the API, which validates the same shape on save: boxes are alternatives (root OR), the rules inside a box
 * all apply (AND), whole numbers only.
 */

export const GUEST_CATEGORY_METRICS = [
    {value: GUEST_CATEGORY_STAYS_FIELD, label: 'Completed stays'},
    {value: GUEST_CATEGORY_NIGHTS_FIELD, label: 'Nights stayed'},
]

export const GUEST_CATEGORY_OPERATORS = [
    DataTypeOperator.MORE_THAN_EQUAL,
    DataTypeOperator.LESS_THAN_EQUAL,
    DataTypeOperator.EQUAL,
    DataTypeOperator.MORE_THAN,
    DataTypeOperator.LESS_THAN,
]

export const GUEST_CATEGORY_MAX_BOXES = 10
export const GUEST_CATEGORY_MAX_RULES_PER_BOX = 20
export const GUEST_CATEGORY_MAX_VALUE = 1_000_000

export const newGuestCategoryRule = (): FilterRule => ({
    field: GUEST_CATEGORY_STAYS_FIELD,
    operator: DataTypeOperator.MORE_THAN_EQUAL,
    longValues: [2],
})

export const newGuestCategoryBox = (): FilterGroup => ({
    operator: DataFilterOperator.AND,
    filterRules: [newGuestCategoryRule()],
})

export const newGuestCategoryFilter = (): Filter => ({
    operator: DataFilterOperator.OR,
    filterGroups: [newGuestCategoryBox()],
})

export const isValidGuestCategoryRule = (rule: FilterRule): boolean => {
    const value = rule.longValues?.[0]
    return GUEST_CATEGORY_METRICS.some(metric => metric.value === rule.field)
        && !!rule.operator && GUEST_CATEGORY_OPERATORS.includes(rule.operator)
        && rule.longValues?.length === 1 && value != null && Number.isInteger(value)
        && value >= 0 && value <= GUEST_CATEGORY_MAX_VALUE
        && !rule.isDeactivated && !rule.isExclusive
}

export const isValidGuestCategoryFilter = (filter: Filter | undefined): boolean => {
    const boxes = filter?.filterGroups ?? []
    if (boxes.length < 1 || boxes.length > GUEST_CATEGORY_MAX_BOXES) return false
    if (boxes.length > 1 && filter?.operator !== DataFilterOperator.OR) return false
    return boxes.every(box => {
        const rules = box.filterRules ?? []
        return !box.subGroups?.length
            && box.operator !== DataFilterOperator.OR
            && rules.length >= 1 && rules.length <= GUEST_CATEGORY_MAX_RULES_PER_BOX
            && rules.every(isValidGuestCategoryRule)
    })
}
